import * as React from "react";
import PropTypes from "prop-types";
import cs from "classnames";
import styles from "./placeholder.module.scss";

const ProductTilePlaceholder = ({ amount }) => {
  const items = [];
  for (let i = 0; i < amount; i += 1) {
    items.push(
      <div
        data-testid="tile-item-box"
        className={cs(styles.tileItemBox, "col-xs-6", "col-sm-4")}
        key={i}
      >
        <div className={cs(styles.tileImage, styles.shimmer)} />
        <div className={cs(styles.tileText, styles.shimmer)} />
        <div className={cs(styles.tileSubtext, styles.shimmer)} />
        <div className={cs(styles.tilePrice, styles.shimmer)} />
      </div>
    );
  }
  return (
    <div data-testid="tile-box" className={cs(styles.tileBox, "row")}>
      {items}
    </div>
  );
};

export const MemoizedProductTilePlaceholder = React.memo(
  ProductTilePlaceholder
);

export const HeroPlaceholder = () => (
  <div data-testid="hero-placeholder">
    <div className={cs(styles.heroItem, styles.shimmer)} />
  </div>
);

const SortPlaceholder = () => (
  <div className={cs(styles.sortBox)}>
    <div className={cs(styles.sortItem, styles.shimmer)} />
    <div className={cs(styles.sortSort, styles.shimmer)} />
  </div>
);

export const GridSortPlaceholder = () => (
  <div className={cs(styles.gridSortBox, "row")}>
    <div className={cs(styles.gridSortResults, "col-xs-12", "col-md-7")}>
      <div className={cs(styles.gridSortResultsText, styles.shimmer)} />
    </div>
    <div className={cs(styles.gridSortFilter, "col-xs-12", "col-md-5")}>
      <div className={cs(styles.gridSortFilterText, styles.shimmer)} />
    </div>
  </div>
);

export const CDPPlaceholder = React.memo(({ tileAmount }) => (
  <div className={styles.placeholder} data-testid="cdp-placeholder">
    <div className={cs(styles.placeholderBox, "wrapper", "container-fluid")}>
      <div className="row">
        <div className={cs(styles.breadcrumbsBox, "col-xs-12")}>
          <div className={cs(styles.breadcrumbsTitle, styles.shimmer)} />
        </div>
        <div className="col-xs-12 col-md-3 tree-section">
          <div className={styles.facetsBox}>
            <div className={cs(styles.facetsTitle, styles.shimmer)} />
            <hr className={cs(styles.facetsDivider)} />
            <div className={cs(styles.facetsItem, styles.shimmer)} />
            <div className={cs(styles.facetsItem, styles.shimmer)} />
            <div className={cs(styles.facetsItem, styles.shimmer)} />
            <div className={cs(styles.facetsItem, styles.shimmer)} />
            <div className={cs(styles.facetsItem, styles.shimmer)} />
            <div className={cs(styles.facetsItem, styles.shimmer)} />
          </div>
        </div>
        <div className="col-xs-12 col-md-9">
          <HeroPlaceholder />
          <div className="row">
            <div className="col-xs-12">
              <SortPlaceholder />
            </div>
          </div>
          <div className="center-xs">
            <ProductTilePlaceholder amount={tileAmount} />
          </div>
        </div>
      </div>
    </div>
  </div>
));
CDPPlaceholder.displayName = "CDPPlaceholder";

ProductTilePlaceholder.propTypes = {
  amount: PropTypes.number,
};

ProductTilePlaceholder.defaultProps = {
  amount: 12,
};

CDPPlaceholder.propTypes = {
  tileAmount: PropTypes.number,
};

CDPPlaceholder.defaultProps = {
  tileAmount: 12,
};
